import React, { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import ChargersMenu from "../components/HomeConfigure/ChargersMenu/ChargersMenu"
import SectorsMenu from "../components/HomeConfigure/SectorsMenu/SectorsMenu"
import Title from "../components/HomeConfigure/Title/Title"

const HomeConfigure = () => {
  const chargersDiv = useRef(null)
  const location = useLocation()

  useEffect(() => {
    if (location.state?.scrollToChargers) {
      chargersDiv.current?.scrollIntoView({ behavior: 'smooth' })
    }
  }, [location.state])

  return (
    <>
      <Title></Title>
      <SectorsMenu scrollRef={chargersDiv}></SectorsMenu>
      <ChargersMenu ref={chargersDiv}></ChargersMenu>
    </>
  )
}

export default HomeConfigure
